import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "datatables.net-bs5"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.stateKey = `datatable:${this.element.id}:state`
    this.state = this.loadState()

    this.initialize()
    this.updateFilterCount()

    window.addEventListener("filters:apply", this.handleFilters)

    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    window.removeEventListener("filters:apply", this.handleFilters)
    document.removeEventListener("turbo:before-cache", this.beforeCache)
  }

  handleFilters = (event) => {
    this.state.filters = event.detail
    this.saveState()
    this.updateFilterCount()
    this.table.ajax.reload()
  }

  initialize() {
    if ($.fn.DataTable.isDataTable(this.element)) return

    this.table = $(this.element).DataTable({
      processing: true,
      serverSide: true,

      order: this.state?.order || [],

      displayStart: this.state?.page
        ? this.state.page * 10
        : 0,

      ajax: {
        url: this.urlValue,
        data: (d) => {
          if (this.state?.filters) {
            d.filtros = this.state.filters
          }
        }
      }
    })

    // 🔥 salva ordenação e paginação
    this.table.on("order.dt page.dt", () => {
      this.state.order = this.table.order()
      this.state.page = this.table.page()
      this.saveState()
    })
  }

  updateFilterCount() {
    const badge = this.element
      .closest(".ui-table-wrapper")
      ?.querySelector("[data-filter-count]")

    if (!badge) return

    const filters = this.state?.filters || {}

    const count = Object.values(filters).reduce((acc, val) => {
      if (Array.isArray(val)) return acc + val.length
      return acc + 1
    }, 0)

    if (count > 0) {
      badge.textContent = count
      badge.classList.remove("d-none")
    } else {
      badge.classList.add("d-none")
    }
  }

  beforeCache = () => {
    if ($.fn.DataTable.isDataTable(this.element)) {
      $(this.element).DataTable().destroy()
    }
  }

  // 🔥 ESCUTA O EVENTO DO MODAL
  handleFilters = (event) => {
    this.state.filters = event.detail
    this.saveState()
    this.updateFilterCount()
    this.table.ajax.reload()
  }

  // 🔥 SALVA NO LOCALSTORAGE
  saveState() {
    // Remove filters se estiver vazio
    if (!this.state.filters || Object.keys(this.state.filters).length === 0) {
      delete this.state.filters
    }

    localStorage.setItem(this.stateKey, JSON.stringify(this.state))
  }

  // 🔥 CARREGA DO LOCALSTORAGE
  loadState() {
    const saved = localStorage.getItem(this.stateKey)
    return saved ? JSON.parse(saved) : {}
  }

  beforeCache = () => {
    if ($.fn.DataTable.isDataTable(this.element)) {
      $(this.element).DataTable().destroy()
    }
  }

}
